import { render, staticRenderFns } from "./FriendRecImage.vue?vue&type=template&id=55029910&"
import script from "./FriendRecImage.vue?vue&type=script&lang=js&"
export * from "./FriendRecImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports